export const xs = 575
export const sm = 576
export const md = 768
export const lg = 992
export const xl = 1200
export const xxl = 1440

export type TBreakpoints = 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

export type TBreakpointVariables = {
  [key in TBreakpoints]: number
}

export const breakpointVariables: TBreakpointVariables = {
  sm,
  md,
  lg,
  xl,
  xxl,
}

export const breakpoints: any = [`${sm}px`, `${md}px`, `${lg}px`, `${xl}px`, `${xxl}px`]
breakpoints.sm = breakpoints[0]
breakpoints.md = breakpoints[1]
breakpoints.lg = breakpoints[2]
breakpoints.xl = breakpoints[3]
breakpoints.xxl = breakpoints[4]

export default breakpointVariables
